import PropTypes from 'prop-types';
import { css, etiColors } from '@eti/styles';

const eventIconStyles = css`
  align-items: center;
  color: ${etiColors.white};
  display: flex;
  height: 1rem;
  justify-content: center;
  margin-right: 0.5rem;
  min-width: 1rem;
  position: relative;
  width: 1rem;

  [dir='rtl'] & {
    margin-left: 0.5rem;
  }

  &::before {
    background: ${etiColors.info.solid};
    border-radius: 50%;
    content: '';
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }
`;

const textStyles = css`
  font-weight: 800;
  line-height: 1;
  position: relative;
  z-index: 1;
`;

const TripDetailsSegmentEventIcon = ({ legendNumber }) => (
  <div className={eventIconStyles}>
    <span className={textStyles}>{legendNumber}</span>
  </div>
);

TripDetailsSegmentEventIcon.propTypes = {
  legendNumber: PropTypes.number,
};

export default TripDetailsSegmentEventIcon;
